import { FC } from 'react';
import Modal from '../modal';

import ErrorGIF from '@/assets/modal/error.gif';

interface IErrorModal {
  isOpen: boolean;
  setIsOpen: (state: boolean) => void;
  errors?: string;
}

const ErrorModal: FC<IErrorModal> = ({ isOpen, setIsOpen, errors }) => {
  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal open={isOpen} onClose={onClose} className={'bg-[#192c46] p-6'}>
      <div className="flex flex-col gap-12">
        <h3 className="text-3xl font-jostMedium text-center mt-6">
          Vi havde et teknisk problem
          <hr className="w-[75%] mx-auto mt-2 border-t border-[#BDE0F5]" />
        </h3>
        <div className="flex justify-center">
          <img src={ErrorGIF} alt="success" className="w-[100px] h-[100px]" />
        </div>
        <div className="flex flex-col items-center">
          <h4 className="font-jostRegular text-lg">
            kontakt venligst vores kundeservice
          </h4>
          <a className="font-jostRegular underline">Tlf. +4566804040</a>
          {errors && (
            <p className="font-jostRegular text-lg">
              Årsagen til problemet: {errors}
            </p>
          )}
        </div>
        <div className="mt-6 text-center">
          <button
            type="button"
            className="w-[201px] h-[40px] border border-[#BDE0F5] text-[#BDE0F5] text-base font-jostSemiBold cursor-pointer rounded-full bg-transparent hover:bg-white hover:text-[#192c46] transition"
            onClick={() => setIsOpen(false)}>
            Luk
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorModal;
